<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter

========================================================================================== -->

<template functional>
	<footer class="the-footer pl-4" :class="classes">
		<span>&copy; {{ new Date().getFullYear() }} <a href="https://canhbaosom.com " target="_blank" rel="nofollow"> CBS</a></span>
	</footer>
</template>

<script>
export default {
	name: "the-footer",
	props: {
		classes: {
			type: String
		}
	}
};
</script>
